import { BookingIntent, StockTargetType } from '../types';
import { BookingRequest } from './booking-request';
import { FromBuilder } from './from-builder';

/**
 * Builder-Stage für Quelle = KFZ. Bietet alle fachlich sinnvollen
 * Ziel-Auswahlen an, die von einem KFZ aus möglich sind.
 *
 * NOTE(intent): Alle KFZ-Direktionen sind im Legacy NICHT über
 * Warehouse::StockMovement gebucht, sondern über den separaten Endpoint
 * `car_management/movement` (siehe `car-loading-save.service.ts`)
 */
export class FromCarBuilder extends FromBuilder {
  /**
   * KFZ → KFZ: Umlagerung zwischen zwei Fahrzeugen. Validierung zur Laufzeit:
   * Funktionsschalter `KFZ-Umlagerung erlaubt` muss aktiv sein, Quell- und
   * Ziel-KFZ tragen das Kennzeichen, `sourceId !== targetId`. Erzeugt ein
   * CarRelocationMovement.
   *
   * @param id ID des Ziel-KFZ
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  public toCar(id: number): BookingRequest {
    return this.next(StockTargetType.CAR, id, BookingIntent.MOVE);
  }

  /**
   * KFZ → Bufferstock: "Entnahme aus KFZ" / Befüllung des Bufferstocks vom
   * KFZ. Erzeugt ein CarTransferMovement.
   *
   * @param id ID des Ziel-Bufferstocks
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  public toBufferstock(id: number): BookingRequest {
    return this.next(StockTargetType.BUFFERSTOCK, id, BookingIntent.MOVE);
  }

  /**
   * KFZ → Maschine: Standard-Service-Buchung. Servicetechniker bucht
   * Serviceartikel aus dem KFZ auf die zu wartende Maschine. Erzeugt ein
   * CarTransferMovement.
   *
   * @param id ID der Ziel-Maschine
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  public toMachine(id: number): BookingRequest {
    return this.next(StockTargetType.MACHINE, id, BookingIntent.MOVE);
  }

  /**
   * KFZ → Müll: Entsorgung direkt aus dem KFZ. Erzeugt ein
   * TrashMovement.
   *
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  public toTrashBin(): BookingRequest {
    return this.nextDisposal(StockTargetType.TRASH_BIN, BookingIntent.TRASH);
  }
}
